import type { INode } from '@ardoq/yfiles';
import {
  MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_SHAPE_HEIGHT as SHAPE_HEIGHT,
  MODERNIZED_BLOCK_DIAGRAM_NODE_LABEL_MARGIN as LABEL_MARGIN,
} from 'yfilesExtensions/styles/modernized/consts';
import { collapsedComponentGroupShapeY } from 'yfilesExtensions/styles/modernized/leafNode/collapsedComponentGroupShapeY';

const collapsedComponentGroupLabelTop = (node: INode) => {
  const {
    layout: { y: nodeY },
  } = node;
  const shapeY = collapsedComponentGroupShapeY(node);
  return nodeY + shapeY + SHAPE_HEIGHT + LABEL_MARGIN;
};
export { collapsedComponentGroupLabelTop };
